<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="务服名称">
                <el-input  v-model="queryForm.serviceName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getWashServiceList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addWashService"
                    >新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editWashService(null)"
                    >修改</el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteWashService(null)"
                    >删除</el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        @click="refreshWashServiceList"
                    >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="washServiceList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="serviceName"
                    label="服务名称"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="speedId"
                    label="服务时效"
                >
                    <template slot-scope="scop">
                        {{scop.row.speed.speedName}}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="sort"
                    label="排序"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkWashService(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editWashService(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteWashService(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="washServiceStates[washServiceState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="washService"
                        ref="washServiceForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="务服名称"
                            prop="serviceName"
                        >
                            <el-input
                                size="small"
                                v-model="washService.serviceName"
                                :disabled="washServiceState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="服务时效"
                            prop="speedId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="washService.speedId"-->
<!--                                :disabled="washServiceState == 'check'"-->
<!--                            ></el-input>-->
                            <el-select
                                clearable
                                style="width: 200px"
                                v-model="washService.speedId"
                                placeholder="请选择"
                                :disabled="washServiceState == 'check'"
                                size="small"
                            >
                                <el-option
                                    v-for="item in washServiceSpeedList"
                                    :label="item.speedName"
                                    :value="item.id"
                                > </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="排序"
                            prop="sort"
                        >
                            <el-input
                                size="small"
                                v-model="washService.sort"
                                :disabled="washServiceState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="washServiceState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetWashServiceList();
                this.getWashServiceList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetWashServiceList();
                this.getWashServiceList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm:{
                serviceName: '', //务服名称
                speedId: '', //服务时效
                sort: '', //排序
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            washServiceState: 'add',
            washServiceStates: {
                add: '新建服务设置',
                check: '查看服务设置',
                edit: '修改服务设置'
            },

            multipleSelection: [],
            washServiceList: [],
            washService: {
                id: '', //ID
                serviceName: '', //务服名称
                speedId: '', //服务时效
                sort: '', //排序
                createUserId: '', //创建者
            },
            btnLoading: false,
            washServiceSpeedList: [],
            rules: {
                id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                serviceName: [{ required: true, message: '务服名称不能为空', trigger: 'blur' }],
                speedId: [{ required: true, message: '服务时效不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                createUserId: [{ required: true, message: '创建者不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        this.getWashServiceList();
        this.getWashServiceSpeedList();
    },
    methods: {
        search(){
            this.isSearch = !this.isSearch;
        },
        getWashServiceSpeedList(){
            get('/wash/servicespeed/findAll').then((res)=>{
                if(res.success){
                    this.washServiceSpeedList = res.list;
                }
            })
        },
        resetWashServiceList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.washServiceList = [];
        },
        resetDialog() {
            this.washServiceState = 'add';
            this.showDialog = false;
            this.queryForm = {
                serviceName: '', //务服名称
                speedId: '', //服务时效
                sort: '', //排序
            };
            this.getWashServiceList();
        },
        closeDialog() {
            this.showDialog = false
            this.washService = {
                id: '', //ID
                serviceName: '', //务服名称
                speedId: '', //服务时效
                sort: '', //排序
            };
        },
        submitForm() {
            if (this.washServiceState == 'add') {
                this.$refs.washServiceForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/wash/washservice/add`,{ ...this.washService }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetWashServiceList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.washServiceState == 'edit') {
                this.$refs.washServiceForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.washService.speed
                        post(`/wash/washservice/edit`,{ ...this.washService }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashServiceList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addWashService() {
            this.showDialog = true;
            this.washServiceState = 'add';
        },
        checkWashService(washServiceId) {
            console.log(washServiceId);
            this.currentWashServiceId = washServiceId;

            this.getWashServiceById();
            this.showDialog = true;
            this.washServiceState = 'check';
        },
        editWashService(washServiceId) {
            console.log('washService', washServiceId);
            if (washServiceId) {
                this.currentWashServiceId = washServiceId;
                this.getWashServiceById();
            } else {
                this.washService = { ...this.washService, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.washServiceState = 'edit';
        },
        deleteWashService(washServiceId) {
            let ids = '';
            if (washServiceId) {
                ids = washServiceId;
            } else {
                ids = this.multipleSelection.map((washService) => washService.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/wash/washservice/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetWashServiceList();
                            this.getWashServiceList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshWashServiceList() {
            this.resetWashServiceList();
            this.getWashServiceList();
        },
        getWashServiceList(query = {}) {
            this.loading = true;
            get(`/wash/washservice/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.washServiceList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getWashServiceById() {
            get(`/wash/washservice/get`,{ id: this.currentWashServiceId }).then((res) =>{
                if(res.success){
                    this.washService = { ...this.washService, ...res.washService };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportWashServiceList() {
            //this.btnLoading = true;
            exprotExcel(`/wash/washservice/export`, {...this.queryForm});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/wash/washservice/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params){
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/wash/washservice/importData`,formData);
            this.refreshWashServiceList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getWashServiceList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getWashServiceList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>